"use client";

import { useState } from "react";
import { PackageSearch, ShieldCheck, ClipboardCheck, FileText, Ship, Tag } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const [activeService, setActiveService] = useState(0);
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const services = [{
    id: 0,
    icon: PackageSearch,
    title: "Global Sourcing & Procurement",
    description: "We connect you with verified suppliers across multiple regions, ensuring competitive pricing and reliable product availability for your commodity needs."
  }, {
    id: 1,
    icon: ShieldCheck,
    title: "Supplier Verification & Audits",
    description: "Our rigorous vetting process includes on-site inspections and compliance checks, guaranteeing that every supplier meets international quality and ethical standards."
  }, {
    id: 2,
    icon: ClipboardCheck,
    title: "Quality Control & Inspection",
    description: "Comprehensive quality assurance protocols at every stage, from sampling to final shipment, ensuring your commodities meet specified standards and certifications."
  }, {
    id: 3,
    icon: FileText,
    title: "Comprehensive Documentation",
    description: "Complete handling of all required paperwork including Certificates of Origin, commercial invoices, packing lists, and compliance documents for seamless customs clearance."
  }, {
    id: 4,
    icon: Ship,
    title: "Freight & Logistics Coordination",
    description: "End-to-end logistics management covering sea, air, and land transport, with real-time tracking and coordination across multiple ports and regions."
  }, {
    id: 5,
    icon: Tag,
    title: "Private Label & Custom Packaging",
    description: "Tailored branding solutions and custom packaging options to help you differentiate your products in the market while maintaining quality and compliance."
  }];
  return <section id="services" ref={sectionRef} className="relative py-24 bg-dark-background overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className={`mb-16 text-center transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
            Services
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto">
            Comprehensive solutions for international trade, from sourcing to delivery
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {}
          <div className={`relative transition-all duration-[var(--duration-slow)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="relative space-y-2">
              {}
              <div className="absolute left-0 w-1 bg-accent rounded-sm transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
              top: `${activeService * 100}px`,
              height: "80px"
            }} />

              {services.map((service, index) => {
              const Icon = service.icon;
              return <button key={service.id} data-index={index} onClick={() => setActiveService(index)} onMouseEnter={() => setActiveService(index)} className={`w-full flex items-center gap-4 p-5 pl-8 rounded-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] text-left ${activeService === index ? "bg-white/5 text-white" : "text-white/60 hover:text-white/80 hover:bg-white/[0.02]"}`}>
                    <Icon className={`size-6 transition-colors duration-[var(--duration-medium)] flex-shrink-0 ${activeService === index ? "text-accent" : "text-white/40"}`} />
                    <span className="font-display font-semibold text-base md:text-lg">
                      {service.title}
                    </span>
                  </button>;
            })}
            </div>
          </div>

          {}
          <div className={`relative flex items-center transition-all duration-[var(--duration-slow)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="relative w-full">
              {services.map((service, index) => {
              const Icon = service.icon;
              return <div key={service.id} data-index={index} className={`absolute inset-0 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${activeService === index ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8 pointer-events-none"}`}>
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-sm p-8 md:p-10 min-h-[280px] flex flex-col justify-center">
                      <Icon className="size-12 text-accent mb-6" />
                      <h3 className="text-2xl md:text-3xl font-display font-bold text-white mb-4">
                        {service.title}
                      </h3>
                      <p className="text-base md:text-lg text-white/70 leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}